import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateUserData } from '../modules/auth/authSlice';
import { IUserResponse } from '../modules/auth/services/type';
import { setOnboardingState } from '../modules/gdp/gdpSlice';
import { useGetUserProfileMutation } from 'services/api';

interface IUseFetchProfileReturnType {
  fetchProfile: () => Promise<IUserResponse>;
  isLoading: boolean;
}

export const useFetchProfile = (): IUseFetchProfileReturnType => {
  const dispatch = useDispatch();
  const [getUserProfile, { isLoading }] = useGetUserProfileMutation();

  const fetchProfile = useCallback(async (): Promise<IUserResponse> => {
    const userResponse: any = await getUserProfile({}).unwrap();
    if (userResponse) dispatch(updateUserData(userResponse));
    dispatch(
      setOnboardingState({
        status: userResponse?.user.status,
        isOnboardMeetingBooked: userResponse?.user.isOnboardMeetingBooked || null,
        showOnboardingTutorial: userResponse?.user.showOnboardingTutorial,
        isLoading: false,
        onboardingStepProgress: userResponse?.user.onboardingStepProgress,
      }),
    );
    return userResponse;
  }, [dispatch, getUserProfile]);

  return { fetchProfile, isLoading };
};
